/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SimilarRequestObjection,
    SimilarRequestObjectionFromJSON,
    SimilarRequestObjectionFromJSONTyped,
    SimilarRequestObjectionToJSON,
    SimilarRequestSource,
    SimilarRequestSourceFromJSON,
    SimilarRequestSourceFromJSONTyped,
    SimilarRequestSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SimilarRequest
 */
export interface SimilarRequest {
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    similarRequestId?: string;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SimilarRequest
     */
    response?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SimilarRequest
     */
    score?: number | null;
    /**
     * 
     * @type {Array<SimilarRequestObjection>}
     * @memberof SimilarRequest
     */
    objections?: Array<SimilarRequestObjection> | null;
    /**
     * 
     * @type {SimilarRequestSource}
     * @memberof SimilarRequest
     */
    source?: SimilarRequestSource;
}

export function SimilarRequestFromJSON(json: any): SimilarRequest {
    return SimilarRequestFromJSONTyped(json, false);
}

export function SimilarRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimilarRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'similarRequestId': !exists(json, 'similarRequestId') ? undefined : json['similarRequestId'],
        'text': !exists(json, 'text') ? undefined : json['text'],
        'response': !exists(json, 'response') ? undefined : json['response'],
        'score': !exists(json, 'score') ? undefined : json['score'],
        'objections': !exists(json, 'objections') ? undefined : (json['objections'] === null ? null : (json['objections'] as Array<any>).map(SimilarRequestObjectionFromJSON)),
        'source': !exists(json, 'source') ? undefined : SimilarRequestSourceFromJSON(json['source']),
    };
}

export function SimilarRequestToJSON(value?: SimilarRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'similarRequestId': value.similarRequestId,
        'text': value.text,
        'response': value.response,
        'score': value.score,
        'objections': value.objections === undefined ? undefined : (value.objections === null ? null : (value.objections as Array<any>).map(SimilarRequestObjectionToJSON)),
        'source': SimilarRequestSourceToJSON(value.source),
    };
}


